import { render } from "./TestClock.vue?vue&type=template&id=48134916&scoped=true"
import script from "./TestClock.vue?vue&type=script&lang=js"
export * from "./TestClock.vue?vue&type=script&lang=js"

import "./TestClock.vue?vue&type=style&index=0&id=48134916&scoped=true&lang=css"

import exportComponent from "D:\\eazyc\\ezDev\\ECS-Cognitive\\cognitive-screening-mobile-app\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-48134916"]])

export default __exports__